/** @format */

export const DEFAULT_TEST_ID = 'section-preview-block';
